"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CartStore = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _cart = require("../../clients/cart.client");
var _flightProduct = _interopRequireWildcard(require("../../factories/flight-product.factory"));
var _ruleProduct = require("../../factories/rule-product.factory");
var _cart2 = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/cart.store"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _head2 = _interopRequireDefault(require("lodash/head"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _cartProduct = require("../../utils/cart-product.utils");
var _constants = require("../../constants");
var _constants2 = require("@tajawal/web-core-sdk-v2/lib/constants");
var _availableAddons = require("../../factories/available-addons.factory");
var _addonTnc = _interopRequireDefault(require("./addon-tnc.store"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var INITIAL = _constants2.API_STATE.INITIAL;
var CREATE_CART = _constants.ACTION_TYPES.CREATE_CART,
  FETCH_CART = _constants.ACTION_TYPES.FETCH_CART,
  UPDATE_CART = _constants.ACTION_TYPES.UPDATE_CART,
  UPDATE_FLIGHT_SSR = _constants.ACTION_TYPES.UPDATE_FLIGHT_SSR;
var CartStore = exports.CartStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, (_class = function (_CoreCartStore) {
  (0, _inherits2.default)(CartStore, _CoreCartStore);
  function CartStore(initialState, $env) {
    var _this;
    (0, _classCallCheck2.default)(this, CartStore);
    _this = _callSuper(this, CartStore, [initialState, $env]);
    _this.$env = void 0;
    _this.addOnTnC = void 0;
    (0, _initializerDefineProperty2.default)(_this, "API_STATE", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "API_ERROR", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "createFlightCart", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "getFlightCart", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "sellFlightSeat", _descriptor5, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "updateMultiFlightSSR", _descriptor6, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "updateFlightSSR", _descriptor7, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "handleAddOns", _descriptor8, (0, _assertThisInitialized2.default)(_this));
    _this.$env = $env;
    _this.updateInitialState(initialState);
    _this.addOnTnC = new _addonTnc.default(initialState === null || initialState === void 0 ? void 0 : initialState.addOnTnC, $env);
    return _this;
  }
  (0, _createClass2.default)(CartStore, [{
    key: "id",
    get: function get() {
      return (0, _get2.default)(this.data, "cartId");
    }
  }, {
    key: "createdAt",
    get: function get() {
      return (0, _get2.default)(this.data, "createdAt");
    }
  }, {
    key: "vat",
    get: function get() {
      return (0, _get2.default)(this.data, "totals.outputVatMeta");
    }
  }, {
    key: "hasVat",
    get: function get() {
      return this.vat > 0;
    }
  }, {
    key: "displayedVat",
    get: function get() {
      return this.$env.currency.convertAndFormatPrice(this.vat);
    }
  }, {
    key: "total",
    get: function get() {
      return (0, _get2.default)(this.data, "totals.total");
    }
  }, {
    key: "displayedTotal",
    get: function get() {
      var _this$$env$currency;
      return (_this$$env$currency = this.$env.currency) === null || _this$$env$currency === void 0 ? void 0 : _this$$env$currency.convertAndFormatPrice(this.total);
    }
  }, {
    key: "isMultiPNR",
    get: function get() {
      var _this$data$options;
      return (_this$data$options = this.data.options) === null || _this$data$options === void 0 ? void 0 : _this$data$options.isMultiProduct;
    }
  }, {
    key: "products",
    get: function get() {
      return (0, _get2.default)(this.data, "products", []);
    }
  }, {
    key: "travellerBreakDowns",
    get: function get() {
      var _this$data, _this$data$displayIte, _lineItems$find, _this$flightProduct;
      var lineItems = ((_this$data = this.data) === null || _this$data === void 0 ? void 0 : (_this$data$displayIte = _this$data.displayItems) === null || _this$data$displayIte === void 0 ? void 0 : _this$data$displayIte.lineItems) || [];
      var flightBreakdowns = ((_lineItems$find = lineItems.find(function (i) {
        return i.type === "flight";
      })) === null || _lineItems$find === void 0 ? void 0 : _lineItems$find.breakdown) || [];
      var travellers = ((_this$flightProduct = this.flightProduct) === null || _this$flightProduct === void 0 ? void 0 : _this$flightProduct.travellers) || [];
      return travellers.map(function (traveller) {
        var matchingBreakdown = flightBreakdowns.find(function (breakdown) {
          return breakdown.type === traveller.type && breakdown.ref === traveller.seatIndex;
        });
        if (matchingBreakdown) {
          var _details$find, _details$find2, _details$find3;
          var details = matchingBreakdown.details || [];
          var fare = ((_details$find = details.find(function (detail) {
            return detail.key === "FARE";
          })) === null || _details$find === void 0 ? void 0 : _details$find.amount) || 0;
          var tax = ((_details$find2 = details.find(function (detail) {
            return detail.key === "TAXES_FEES";
          })) === null || _details$find2 === void 0 ? void 0 : _details$find2.amount) || 0;
          var luggage = ((_details$find3 = details.find(function (detail) {
            return detail.key === "LUGGAGE";
          })) === null || _details$find3 === void 0 ? void 0 : _details$find3.amount) || 0;
          return _objectSpread(_objectSpread({}, traveller), {}, {
            displayTotals: _objectSpread(_objectSpread({}, traveller.displayTotals || {}), {}, {
              base: fare.toFixed(2),
              tax: tax.toFixed(2),
              luggage: luggage.toFixed(2),
              total: (matchingBreakdown.total || 0).toFixed(2)
            })
          });
        }
        return _objectSpread(_objectSpread({}, traveller), {}, {
          displayTotals: _objectSpread(_objectSpread({}, traveller.displayTotals || {}), {}, {
            base: "0.00",
            tax: "0.00",
            luggage: "0.00",
            total: "0.00"
          })
        });
      });
    }
  }, {
    key: "validProducts",
    get: function get() {
      return this.products.filter(_cartProduct.isValidProduct);
    }
  }, {
    key: "hasFlightProduct",
    get: function get() {
      return this.validProducts.some(_cartProduct.isFlightProduct);
    }
  }, {
    key: "flightProduct",
    get: function get() {
      return this.isMultiPNR ? this.combinedFlightProduct : this.singleFlightProduct;
    }
  }, {
    key: "singleFlightProduct",
    get: function get() {
      var validProducts = this.validProducts || [];
      var flightProduct = (0, _head2.default)(validProducts.filter(_cartProduct.isFlightProduct));
      return (0, _flightProduct.default)({
        flightProduct: flightProduct,
        $currency: this.$env.currency
      });
    }
  }, {
    key: "availableflightProducts",
    get: function get() {
      var _this2 = this;
      var validProducts = this.validProducts || [];
      var flightProducts = validProducts.filter(_cartProduct.isFlightProduct);
      return (0, _map2.default)(flightProducts, function (flightProduct) {
        return (0, _flightProduct.default)({
          flightProduct: flightProduct,
          $currency: _this2.$env.currency
        });
      });
    }
  }, {
    key: "combinedFlightProduct",
    get: function get() {
      return (0, _flightProduct.combineFlightProducts)(this.availableflightProducts, this.$env.currency);
    }
  }, {
    key: "rules",
    get: function get() {
      var ruleFactory = (0, _ruleProduct.makeRuleProductFactory)(this.$env.currency.convertAndFormatPrice);
      return this.validProducts.filter(_cartProduct.isDisplayable).map(ruleFactory);
    }
  }, {
    key: "paxAddons",
    get: function get() {
      var _this$flightProduct2, _this$flightProduct3;
      var addOnRuleFactory = (0, _availableAddons.makeAddOnRuleFactory)(this.$env.currency.convertAndFormatPriceValue);
      return addOnRuleFactory((_this$flightProduct2 = this.flightProduct) === null || _this$flightProduct2 === void 0 ? void 0 : _this$flightProduct2.availableAddOns.filter(_cartProduct.isNotFreeTripInsurance), (_this$flightProduct3 = this.flightProduct) === null || _this$flightProduct3 === void 0 ? void 0 : _this$flightProduct3.addOnProducts);
    }
  }, {
    key: "allAddons",
    get: function get() {
      var _this$flightProduct4, _this$flightProduct5;
      var addOnRuleFactory = (0, _availableAddons.makeAddOnRuleFactory)(this.$env.currency.convertAndFormatPriceValue);
      return addOnRuleFactory((_this$flightProduct4 = this.flightProduct) === null || _this$flightProduct4 === void 0 ? void 0 : _this$flightProduct4.availableAddOns, (_this$flightProduct5 = this.flightProduct) === null || _this$flightProduct5 === void 0 ? void 0 : _this$flightProduct5.addOnProducts);
    }
  }, {
    key: "travellerFormAddons",
    get: function get() {
      var _this$flightProduct6, _this$flightProduct7;
      var addOnRuleFactory = (0, _availableAddons.makeAddOnRuleFactory)(this.$env.currency.convertAndFormatPriceValue);
      return addOnRuleFactory((_this$flightProduct6 = this.flightProduct) === null || _this$flightProduct6 === void 0 ? void 0 : _this$flightProduct6.availableAddOns.filter(_cartProduct.isFreeTripInsurance), (_this$flightProduct7 = this.flightProduct) === null || _this$flightProduct7 === void 0 ? void 0 : _this$flightProduct7.addOnProducts);
    }
  }, {
    key: "appliedAddOns",
    get: function get() {
      var _this3 = this;
      return this.allAddons.filter(function (addOn) {
        return addOn.isAddOnApplied && !_this3.isLoading(addOn.code);
      });
    }
  }, {
    key: "updateAddOn",
    value: function updateAddOn(_ref) {
      var cartId = _ref.cartId,
        addOn = _ref.addOn,
        _ref$errorHandler = _ref.errorHandler,
        errorHandler = _ref$errorHandler === void 0 ? function () {
          return null;
        } : _ref$errorHandler;
      var appliedAddOnsCodes = this.appliedAddOns.map(function (addOn) {
        return addOn.code;
      });
      appliedAddOnsCodes.push(addOn);
      this.handleAddOns({
        cartId: cartId,
        actionAddon: addOn,
        addOns: Array.from(new Set(appliedAddOnsCodes)),
        errorHandler: errorHandler
      });
    }
  }, {
    key: "removeAddOn",
    value: function removeAddOn(_ref2) {
      var cartId = _ref2.cartId,
        addOn = _ref2.addOn,
        _ref2$errorHandler = _ref2.errorHandler,
        errorHandler = _ref2$errorHandler === void 0 ? function () {
          return null;
        } : _ref2$errorHandler;
      var appliedAddOnsCodes = this.appliedAddOns.map(function (addOn) {
        return addOn.code;
      });
      appliedAddOnsCodes.splice(appliedAddOnsCodes.indexOf(addOn), 1);
      this.handleAddOns({
        cartId: cartId,
        actionAddon: addOn,
        addOns: appliedAddOnsCodes,
        errorHandler: errorHandler
      });
    }
  }, {
    key: "resetPropertyState",
    value: function resetPropertyState(state) {
      this.API_STATE[state] = INITIAL;
      this.API_ERROR[state] = null;
    }
  }, {
    key: "resetFlightsApiState",
    value: function resetFlightsApiState() {
      var _this$API_STATE, _this$API_ERROR;
      this.API_STATE = (_this$API_STATE = {}, _this$API_STATE[CREATE_CART] = INITIAL, _this$API_STATE[FETCH_CART] = INITIAL, _this$API_STATE[UPDATE_CART] = INITIAL, _this$API_STATE[UPDATE_FLIGHT_SSR] = INITIAL, _this$API_STATE);
      this.API_ERROR = (_this$API_ERROR = {}, _this$API_ERROR[CREATE_CART] = null, _this$API_ERROR[FETCH_CART] = null, _this$API_ERROR[UPDATE_CART] = null, _this$API_ERROR[UPDATE_FLIGHT_SSR] = null, _this$API_ERROR);
    }
  }]);
  return CartStore;
}(_cart2.default), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _ref3;
    return _ref3 = {}, _ref3[CREATE_CART] = INITIAL, _ref3[FETCH_CART] = INITIAL, _ref3[UPDATE_CART] = INITIAL, _ref3[UPDATE_FLIGHT_SSR] = INITIAL, _ref3;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_ERROR", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _ref4;
    return _ref4 = {}, _ref4[CREATE_CART] = null, _ref4[FETCH_CART] = null, _ref4[UPDATE_CART] = null, _ref4[UPDATE_FLIGHT_SSR] = null, _ref4;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "id", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "id"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "createdAt", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "createdAt"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "vat", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vat"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasVat", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasVat"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedVat", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedVat"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "total", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "total"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedTotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedTotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isMultiPNR", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMultiPNR"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "products", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "products"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "travellerBreakDowns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "travellerBreakDowns"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "validProducts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "validProducts"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasFlightProduct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasFlightProduct"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "flightProduct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "flightProduct"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "singleFlightProduct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "singleFlightProduct"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "availableflightProducts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableflightProducts"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "combinedFlightProduct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "combinedFlightProduct"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rules", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rules"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paxAddons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paxAddons"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "allAddons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allAddons"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "travellerFormAddons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "travellerFormAddons"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "appliedAddOns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "appliedAddOns"), _class.prototype), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "createFlightCart", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _mobx.flow)(function createFlightCart(_ref5) {
      var _this4 = this;
      var itineraryId = _ref5.itineraryId,
        isV1 = _ref5.isV1,
        _ref5$errorHandler = _ref5.errorHandler,
        errorHandler = _ref5$errorHandler === void 0 ? function () {
          return null;
        } : _ref5$errorHandler;
      return _regeneratorRuntime().mark(function _callee() {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this4.setAPILoading(CREATE_CART);
              _context.prev = 1;
              _context.next = 4;
              return _cart.CartClient.createCart(itineraryId, isV1);
            case 4:
              response = _context.sent;
              _this4.onSuccess(response, CREATE_CART);
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              _this4.onError(_context.t0, errorHandler, CREATE_CART);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      })();
    });
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "getFlightCart", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _mobx.flow)(function getFlightCart(_ref6) {
      var _this5 = this;
      var cartId = _ref6.cartId,
        searchParams = _ref6.searchParams,
        _ref6$errorHandler = _ref6.errorHandler,
        errorHandler = _ref6$errorHandler === void 0 ? function () {
          return null;
        } : _ref6$errorHandler;
      return _regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.setAPILoading(FETCH_CART);
              _context2.prev = 1;
              _context2.next = 4;
              return _cart.CartClient.getCart(cartId, searchParams);
            case 4:
              response = _context2.sent;
              _this5.onSuccess(response, FETCH_CART);
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              _this5.onError(_context2.t0, errorHandler, FETCH_CART);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 8]]);
      })();
    });
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sellFlightSeat", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _mobx.flow)(function sellFlightSeat(_ref7) {
      var _this6 = this;
      var payload = _ref7.payload,
        isV3 = _ref7.isV3,
        _ref7$errorHandler = _ref7.errorHandler,
        errorHandler = _ref7$errorHandler === void 0 ? function () {
          return null;
        } : _ref7$errorHandler;
      return _regeneratorRuntime().mark(function _callee3() {
        var method, sellSeatPayload, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this6.setAPILoading(UPDATE_CART);
              _context3.prev = 1;
              if (!isV3) {
                _context3.next = 6;
                break;
              }
              method = _this6.isMultiPNR ? _cart.CartClient.updateMultiSSR : _cart.CartClient.updateSSR;
              _context3.next = 6;
              return method((0, _pick2.default)(payload, ["cartId", "ssr"]));
            case 6:
              sellSeatPayload = isV3 ? (0, _omit2.default)(payload, ["ssr"]) : payload;
              _context3.next = 9;
              return _cart.CartClient.sellSeat(sellSeatPayload, isV3);
            case 9:
              response = _context3.sent;
              _this6.onSuccess(response, UPDATE_CART);
              _context3.next = 16;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](1);
              _this6.onError(_context3.t0, errorHandler, UPDATE_CART);
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 13]]);
      })();
    });
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateMultiFlightSSR", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _mobx.flow)(function updateFlightSSR(_ref8) {
      var _this7 = this;
      var payload = _ref8.payload,
        _ref8$errorHandler = _ref8.errorHandler,
        errorHandler = _ref8$errorHandler === void 0 ? function () {
          return null;
        } : _ref8$errorHandler;
      return _regeneratorRuntime().mark(function _callee4() {
        var response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this7.setAPILoading(UPDATE_FLIGHT_SSR);
              _context4.prev = 1;
              _context4.next = 4;
              return _cart.CartClient.updateMultiSSR(payload);
            case 4:
              response = _context4.sent;
              _this7.onSuccess(response, UPDATE_FLIGHT_SSR);
              _context4.next = 11;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);
              _this7.onError(_context4.t0, errorHandler, UPDATE_FLIGHT_SSR);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 8]]);
      })();
    });
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateFlightSSR", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _mobx.flow)(function updateFlightSSR(_ref9) {
      var _this8 = this;
      var payload = _ref9.payload,
        _ref9$errorHandler = _ref9.errorHandler,
        errorHandler = _ref9$errorHandler === void 0 ? function () {
          return null;
        } : _ref9$errorHandler;
      return _regeneratorRuntime().mark(function _callee5() {
        var response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this8.setAPILoading(UPDATE_FLIGHT_SSR);
              _context5.prev = 1;
              _context5.next = 4;
              return _cart.CartClient.updateSSR(payload);
            case 4:
              response = _context5.sent;
              _this8.onSuccess(response, UPDATE_FLIGHT_SSR);
              _context5.next = 11;
              break;
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);
              _this8.onError(_context5.t0, errorHandler, UPDATE_FLIGHT_SSR);
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[1, 8]]);
      })();
    });
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "handleAddOns", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _mobx.flow)(function handleAddOn(_ref10) {
      var _this9 = this;
      var cartId = _ref10.cartId,
        actionAddon = _ref10.actionAddon,
        addOns = _ref10.addOns,
        _ref10$errorHandler = _ref10.errorHandler,
        errorHandler = _ref10$errorHandler === void 0 ? function () {
          return null;
        } : _ref10$errorHandler;
      return _regeneratorRuntime().mark(function _callee6() {
        var response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this9.resetPropertyState(actionAddon);
              _this9.setAPILoading(actionAddon);
              _context6.prev = 2;
              _context6.next = 5;
              return _cart.CartClient.updateAddOns(cartId, addOns);
            case 5:
              response = _context6.sent;
              _this9.onSuccess(response, actionAddon);
              _context6.next = 12;
              break;
            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](2);
              _this9.onError(_context6.t0, errorHandler, actionAddon);
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[2, 9]]);
      })();
    });
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateAddOn", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "updateAddOn"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "removeAddOn", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "removeAddOn"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetPropertyState", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "resetPropertyState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetFlightsApiState", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "resetFlightsApiState"), _class.prototype)), _class));